<template>
  <nav :aria-label="$texts('skipLinks', 'Skip links')">
    <ul ref="el" class="skip-links" tabindex="-1">
      <li v-for="(link, index) in links" :key="index">
        <a :href="`#${link.target}`" @click.prevent="onClick(link)">
          <span>{{ link.label }}</span>
          <span>{{ index }}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
interface SkipLink {
  target: string
  label: string
}

const el = ref<HTMLUListElement | null>(null)
const { $texts } = useNuxtApp()

const links = computed<SkipLink[]>(() => {
  return [
    {
      target: 'main-content',
      label: $texts('skipToMainContent', 'Skip to main content'),
    },
    {
      target: 'main-navigation',
      label: $texts('skipToNavigation', 'Skip to navigation'),
    },
  ]
})

const route = useRoute()
const router = useRouter()

watch(
  () => route.path,
  (path, newPath) => {
    if (path !== newPath && el.value) {
      el.value.focus()
    }
  },
)

function onClick(link: SkipLink) {
  router.push({ hash: `#${link.target}` })
  const target = document.getElementById(link.target)
  if (target) {
    target.focus()
  }
}
</script>

<style lang="postcss">
.skip-links {
  @apply relative z-[1000000] h-0 w-0 outline-0;
  a {
    @apply flex min-w-[300px] items-center justify-between overflow-hidden rounded-large outline-0;
    span {
      height: 3rem;
      @apply flex items-center;
      &:first-child {
        padding: 0 1rem;
      }
      &:last-child {
        @apply bg-blue-800;
        width: 3rem;

        justify-content: center;
      }
    }
    white-space: nowrap;
    @apply bg-blue-400;
    color: white;
    position: absolute;
    top: 1rem;
    left: -99999px;
    font-weight: bold;
    &:focus {
      left: 1rem;
    }
  }
}
</style>
